class EUHeroSlider extends HTMLElement {
  connectedCallback() {
    clearTimeout(this.initTimer);
    this.initTimer = setTimeout(() => this.init(), 0);
  }
  init() {
    if (this.controller) return;
    this.slides = [...this.querySelectorAll('[data-slide]')];
    this.dots = [...this.querySelectorAll('[data-dot]')];
    if (!this.slides.length) return;
    this.controller = new AbortController();
    const on = (target, name, handler, options = {}) => target.addEventListener(name, handler, { ...options, signal: this.controller.signal });
    this.index = 0;
    this.delay = Number(this.dataset.delay) || 3000;
    this.show(0);
    const go = delta => { this.show(this.index + delta); this.schedule(); };
    const previous = this.querySelector('[data-prev]');
    const next = this.querySelector('[data-next]');
    if (previous) on(previous, 'click', () => go(-1));
    if (next) on(next, 'click', () => go(1));
    this.dots.forEach((dot, index) => on(dot, 'click', () => { this.show(index); this.schedule(); }));
    on(this, 'dragstart', event => { if (event.target.closest('.eus__media')) event.preventDefault(); });
    on(this, 'pointerdown', event => {
      if (this.dataset.swipe !== 'true' || !event.isPrimary || event.button !== 0 || this.slides.length < 2) return;
      if (!event.target.closest('.eus__media,.eus__shade') || event.target.closest('a,button,input,select')) return;
      this.gesture = { id: event.pointerId, x: event.clientX, y: event.clientY };
      clearTimeout(this.timer);
      this.setPointerCapture(event.pointerId);
      this.classList.add('eus--dragging');
    });
    on(this, 'pointerup', event => {
      if (!this.gesture || event.pointerId !== this.gesture.id) return;
      const dx = event.clientX - this.gesture.x;
      const dy = event.clientY - this.gesture.y;
      this.gesture = null;
      this.classList.remove('eus--dragging');
      if (this.hasPointerCapture(event.pointerId)) this.releasePointerCapture(event.pointerId);
      if (Math.abs(dx) >= Number(this.dataset.swipeDistance || 45) && Math.abs(dx) > Math.abs(dy) * 1.4) this.show(this.index + (dx < 0 ? 1 : -1));
      this.schedule();
    });
    const cancel = () => { this.gesture = null; this.classList.remove('eus--dragging'); this.schedule(); };
    on(this, 'pointercancel', cancel);
    on(this, 'lostpointercapture', () => { if (this.gesture) cancel(); });
    on(this, 'focusin', () => clearTimeout(this.timer));
    on(this, 'focusout', () => setTimeout(() => this.schedule(), 0));
    on(document, 'visibilitychange', () => this.schedule());
    on(this, 'shopify:block:select', event => {
      const slide = event.target.closest('[data-slide]');
      const index = this.slides.indexOf(slide);
      if (index >= 0) { this.editorSelected = true; this.show(index); clearTimeout(this.timer); }
    });
    on(this, 'shopify:block:deselect', () => { this.editorSelected = false; this.schedule(); });
    this.dataset.ready = 'true';
    this.schedule();
  }
  schedule() {
    clearTimeout(this.timer);
    if (!this.isConnected || this.dataset.autoplay !== 'true' || this.slides.length < 2 || document.hidden || this.gesture || this.editorSelected || this.contains(document.activeElement)) return;
    this.timer = setTimeout(() => { this.show(this.index + 1); this.schedule(); }, this.delay);
  }
  show(index) {
    if (!this.slides?.length) return;
    this.index = (index + this.slides.length) % this.slides.length;
    this.slides.forEach((slide, i) => { slide.hidden = i !== this.index; });
    this.dots.forEach((dot, i) => dot.setAttribute('aria-current', i === this.index ? 'true' : 'false'));
  }
  disconnectedCallback() {
    clearTimeout(this.initTimer);
    clearTimeout(this.timer);
    this.controller?.abort();
    this.controller = null;
    this.gesture = null;
    this.editorSelected = false;
    delete this.dataset.ready;
  }
}

class EUProductTabs extends HTMLElement{connectedCallback(){if(this.dataset.ready==='true')return;clearTimeout(this.initTimer);this.initTimer=setTimeout(()=>this.init(),0)}init(){if(this.dataset.ready==='true')return;const tabs=[...this.querySelectorAll('[data-tab]')],panels=[...this.querySelectorAll('[data-panel]')];if(!tabs.length)return;this.dataset.ready='true';panels.forEach(panel=>this.setupPanel(panel));tabs.forEach((tab,i)=>tab.addEventListener('click',()=>{tabs.forEach((t,n)=>t.setAttribute('aria-selected',n===i?'true':'false'));panels.forEach((p,n)=>p.hidden=n!==i)}))}setupPanel(panel){const cards=[...panel.querySelectorAll('[data-product-card]')],initial=Math.max(1,Number(panel.dataset.initialProducts||6)),button=panel.querySelector('[data-show-more]'),wrap=button?.closest('.eup__more-wrap');if(!button||cards.length<=initial){if(wrap)wrap.hidden=true;return}const label=button.querySelector('[data-show-more-text]');const render=expanded=>{cards.forEach((card,i)=>card.hidden=!expanded&&i>=initial);button.setAttribute('aria-expanded',expanded?'true':'false');if(label)label.textContent=expanded?button.dataset.hideLabel:button.dataset.showLabel};render(false);button.addEventListener('click',()=>{const expanded=button.getAttribute('aria-expanded')==='true';render(!expanded);if(expanded)panel.scrollIntoView({behavior:'smooth',block:'start'})})}disconnectedCallback(){clearTimeout(this.initTimer)}}
if(!customElements.get('eu-hero-slider'))customElements.define('eu-hero-slider',EUHeroSlider);if(!customElements.get('eu-product-tabs'))customElements.define('eu-product-tabs',EUProductTabs);
